var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-container-sitc",
      staticStyle: { "padding-bottom": "0px" },
    },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          { staticClass: "filter-container-new" },
          [
            _c(
              "el-form",
              {
                ref: "listQuery",
                attrs: {
                  model: _vm.listQuery,
                  rules: _vm.rules,
                  "label-position": "top",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "reqired",
                            attrs: {
                              label: _vm.$t("home.portOfDeparture"),
                              prop: "pol",
                            },
                          },
                          [
                            _c("glPort", {
                              model: {
                                value: _vm.listQuery.pol,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "pol", $$v)
                                },
                                expression: "listQuery.pol",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("div", { staticClass: "filter-label " }, [
                          _c("span", { staticClass: "is-reqired" }, [
                            _vm._v(_vm._s(_vm.$t("home.destinationPort"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "0" },
                                  on: { change: _vm.getValueTranster },
                                  model: {
                                    value: _vm.listQuery.isTs,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listQuery, "isTs", $$v)
                                    },
                                    expression: "listQuery.isTs",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("home.through")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1" },
                                  on: { change: _vm.getValueTranster },
                                  model: {
                                    value: _vm.listQuery.isTs,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listQuery, "isTs", $$v)
                                    },
                                    expression: "listQuery.isTs",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("home.transfer")))]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "pod" } },
                          [
                            _c("glPort", {
                              model: {
                                value: _vm.listQuery.pod,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "pod", $$v)
                                },
                                expression: "listQuery.pod",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("div", { staticClass: "filter-label " }, [
                          _c("span", { staticClass: "is-reqired" }, [
                            _vm._v(_vm._s(_vm.$t("home.startTime"))),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "text-align": "right" } },
                            [
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "1" },
                                  on: { change: _vm.getValue },
                                  model: {
                                    value: _vm.filterForm.radio,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterForm, "radio", $$v)
                                    },
                                    expression: "filterForm.radio",
                                  },
                                },
                                [_vm._v("ETD")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-radio",
                                {
                                  attrs: { label: "2" },
                                  on: { change: _vm.getValue },
                                  model: {
                                    value: _vm.filterForm.radio,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.filterForm, "radio", $$v)
                                    },
                                    expression: "filterForm.radio",
                                  },
                                },
                                [_vm._v("ETA")]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "time" } },
                          [
                            _c("el-date-picker", {
                              attrs: { type: "date" },
                              on: { change: _vm.changeTime },
                              model: {
                                value: _vm.listQuery.time,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "time", $$v)
                                },
                                expression: "listQuery.time",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("div", { staticStyle: { height: "28px" } }),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "keyword" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { placeholder: "请选择" },
                                on: { change: _vm.changeSelect },
                                model: {
                                  value: _vm.filterForm.selectTime,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "selectTime", $$v)
                                  },
                                  expression: "filterForm.selectTime",
                                },
                              },
                              _vm._l(_vm.options, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label:
                                      _vm.language === "zh"
                                        ? item.labelZh
                                        : item.labelEh,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("home.portofTransshipment"),
                              prop: "pot",
                            },
                          },
                          [
                            _c("glPort", {
                              model: {
                                value: _vm.listQuery.pot,
                                callback: function ($$v) {
                                  _vm.$set(_vm.listQuery, "pot", $$v)
                                },
                                expression: "listQuery.pot",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.listQuery.isTs == "1"
                      ? _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "reqired",
                                attrs: {
                                  label: _vm.$t("home.receipt"),
                                  prop: "por",
                                },
                              },
                              [
                                _c("glPort", {
                                  model: {
                                    value: _vm.listQuery.por,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.listQuery, "por", $$v)
                                    },
                                    expression: "listQuery.por",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        staticStyle: { "margin-top": "28px" },
                        attrs: { span: 6 },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: { click: _vm.handleSearch },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.search")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            on: { click: _vm.handleReset },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.reset")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: { click: _vm.handleOpen },
                          },
                          [_vm._v(_vm._s(_vm.$t("home.connection")))]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "filter-container-content" },
        [
          _c(
            "el-form",
            {
              ref: "filterForm",
              attrs: {
                "label-width": "100px",
                rules: _vm.rules,
                model: _vm.filterForm,
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 14 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "vesselCode",
                            label: _vm.$t("home.vesselName") + "：",
                          },
                        },
                        [
                          _c("glVessel", {
                            model: {
                              value: _vm.filterForm.vesselCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "vesselCode", $$v)
                              },
                              expression: "filterForm.vesselCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "keyword",
                            label: _vm.$t("home.route") + "：",
                          },
                        },
                        [
                          _c("glRoute", {
                            model: {
                              value: _vm.filterForm.serviceLineCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "serviceLineCode", $$v)
                              },
                              expression: "filterForm.serviceLineCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 5 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "btn-primary",
                          attrs: { type: "primary" },
                          on: { click: _vm.handleSelectVessel },
                        },
                        [_vm._v(_vm._s(_vm.$t("home.filter")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              staticClass: "table-container-new",
            },
            [
              _c(
                "el-table",
                {
                  ref: "table",
                  staticStyle: { width: "100%" },
                  attrs: {
                    border: "",
                    data: _vm.tableData,
                    height: "calc(100vh - 420px)",
                  },
                },
                [
                  _vm.listQuery.isTs == "1"
                    ? _c("el-table-column", {
                        attrs: { width: "1", type: "expand" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (props) {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _vm._l(
                                        props.row.routeList,
                                        function (item, index) {
                                          return _c(
                                            "div",
                                            { key: index, staticClass: "li1" },
                                            [
                                              _c("div", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "align-items": "center",
                                                    },
                                                  },
                                                  [
                                                    index == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "node",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(item.pol)
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    index !== 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass: "node",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.row
                                                                  .routeList[
                                                                  index - 1
                                                                ].pod
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    index == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "nodeTime",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.parseTime(
                                                                  item.etd,
                                                                  "{y}-{m}-{d} {h}:{i}"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    index !== 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "nodeTime",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.parseTime(
                                                                  props.row
                                                                    .routeList[
                                                                    index - 1
                                                                  ].eta,
                                                                  "{y}-{m}-{d} {h}:{i}"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    index == 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "nodeTime",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "(" +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "home.departure"
                                                                  )
                                                                ) +
                                                                ")"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    index !== 0
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "nodeTime",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "(" +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "home.arrival"
                                                                  )
                                                                ) +
                                                                ")"
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    _c("div", {
                                                      staticClass: "borderLeft",
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                index == 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "nodeText",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.terminalCodeF
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                index !== 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "nodeText",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.row.routeList[
                                                              index - 1
                                                            ].terminalCodeT
                                                          ) +
                                                            " ->" +
                                                            _vm._s(
                                                              item.terminalCodeF
                                                            ) +
                                                            "   " +
                                                            _vm._s(
                                                              _vm.parseTime(
                                                                item.eta,
                                                                "{y}-{m}-{d} {h}:{i}"
                                                              )
                                                            ) +
                                                            "(" +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "home.departure"
                                                              )
                                                            ) +
                                                            ")"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "node-content" },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "port" },
                                                    [
                                                      _vm._v(
                                                        "\n            " +
                                                          _vm._s(
                                                            item.vesselName
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            item.voyageNo
                                                          ) +
                                                          "\n            "
                                                      ),
                                                      _c("img", {
                                                        staticStyle: {
                                                          width: "24px",
                                                        },
                                                        attrs: {
                                                          src: require("@/assets/img/ic_eyes.png"),
                                                          alt: "",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "portTime" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.convertHoursToDaysAndHours(
                                                            item.usedHours
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "node_route_box",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "node_route_text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "home.route"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "node_route_con",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.serviceLineCode
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("img", {
                                              staticStyle: {
                                                width: "24px",
                                                "margin-left": "10px",
                                              },
                                              attrs: {
                                                src: require("@/assets/img/ic_content.png"),
                                                alt: "",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "nodeLast",
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    props.row.routeList[
                                                      props.row.routeList
                                                        .length - 1
                                                    ].pod
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "nodeTime" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.parseTime(
                                                      props.row.routeList[
                                                        props.row.routeList
                                                          .length - 1
                                                      ].eta,
                                                      "{y}-{m}-{d} {h}:{i}"
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "nodeTime" },
                                              [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      _vm.$t("home.arrival")
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "nodeText",
                                            staticStyle: {
                                              "margin-left": "21px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                props.row.routeList[
                                                  props.row.routeList.length - 1
                                                ].terminalCodeT
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    2
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1772079524
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      width: "60px",
                      type: "index",
                      label: _vm.$t("home.No"),
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      sortable: _vm.sortFlag,
                      flex: "1",
                      label: _vm.$t("home.route"),
                      prop: "serviceLineCode",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      sortable: _vm.sortFlag,
                      flex: "1",
                      label: _vm.$t("home.vesselAndVoyage"),
                      prop: "vessel",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.vesselName))]),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                _vm._s(scope.row.voyageNo) +
                                  _vm._s(scope.row.voyageLeg)
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        sortable: _vm.sortFlag,
                        "min-width": "160px",
                        label: _vm.$t("home.portOfDeparture"),
                        prop: "portOfDeparture",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "table_start",
                                    staticStyle: {
                                      display: "flex",
                                      width: "42px",
                                    },
                                  },
                                  [_vm._v("POL")]
                                ),
                                _vm._v(_vm._s(scope.row.pol)),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticStyle: { display: "flex" } }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "table_end",
                                    staticStyle: { width: "42px" },
                                  },
                                  [_vm._v("POD")]
                                ),
                                _vm._v(_vm._s(scope.row.pod)),
                              ]),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("home.portOfDeparture"))),
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticStyle: {
                            width: "30px",
                            height: "20px",
                            "vertical-align": "middle",
                          },
                          attrs: {
                            src: require("@/assets/img/youjiantou.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("home.destinationPort"))),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      "min-width": "140px",
                      prop: "terminalCode",
                      label: "Terminal",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-table-column",
                    {
                      attrs: {
                        sortable: _vm.sortFlag,
                        "min-width": "200px",
                        label: _vm.$t("home.sailingTime"),
                        prop: "sailingTime",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "table_start",
                                            staticStyle: { width: "74px" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "table_start_pod",
                                              },
                                              [_vm._v("POL")]
                                            ),
                                            _c("span", [_vm._v("ETD")]),
                                          ]
                                        ),
                                        _vm._v(
                                          _vm._s(
                                            scope.row.polEtdStr
                                              ? _vm.parseTime(
                                                  scope.row.polEtdStr,
                                                  "{y}-{m}-{d}"
                                                )
                                              : ""
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticStyle: { display: "flex" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "table_end",
                                            staticStyle: { width: "74px" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "table_start_pod",
                                              },
                                              [_vm._v("POD")]
                                            ),
                                            _c("span", [_vm._v("ETA")]),
                                          ]
                                        ),
                                        _vm._v(
                                          _vm._s(
                                            scope.row.podEtaStr
                                              ? _vm.parseTime(
                                                  scope.row.podEtaStr,
                                                  "{y}-{m}-{d}"
                                                )
                                              : ""
                                          )
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticStyle: {
                                      width: "15px",
                                      height: "39px",
                                    },
                                    attrs: {
                                      src: require("@/assets/img/ic_xiajiantou.png"),
                                      alt: "",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                    },
                                    attrs: {
                                      src: require("@/assets/img/vessel.png"),
                                      alt: "",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("template", { slot: "header" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("home.sailingTime"))),
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          staticStyle: {
                            width: "30px",
                            height: "20px",
                            "vertical-align": "middle",
                          },
                          attrs: {
                            src: require("@/assets/img/youjiantou.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("home.arrivalTime"))),
                        ]),
                      ]),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      sortable: _vm.sortFlag,
                      "min-width": "150px",
                      label: "Original ETD",
                      prop: "orgEtdStr",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      sortable: _vm.sortFlag,
                      "min-width": "140px",
                      label: "CY Cut Time",
                      prop: "cutOffTime",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      sortable: _vm.sortFlag,
                      "min-width": "120px",
                      label: "Sailing Days",
                      prop: "sailingTime",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [_vm._v(_vm._s(scope.row.sailingTime))]),
                            _vm._v(" "),
                            scope.row.status === "3"
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "14px",
                                        height: "14px",
                                      },
                                      attrs: {
                                        src: require("@/assets/img/ic_chenggong.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#14CCAD",
                                          "margin-left": "5px",
                                        },
                                      },
                                      [_vm._v("Space")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status === "1"
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "14px",
                                        height: "14px",
                                      },
                                      attrs: {
                                        src: require("@/assets/img/ic_redStatus.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#FF5967",
                                          "margin-left": "5px",
                                        },
                                      },
                                      [_vm._v("No Space")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            scope.row.status === "2"
                              ? _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "align-items": "center",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "14px",
                                        height: "14px",
                                      },
                                      attrs: {
                                        src: require("@/assets/img/ic_jinggao.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "#FF791A",
                                          "margin-left": "5px",
                                        },
                                      },
                                      [_vm._v("Space Tight")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "",
                      label: _vm.$t("home.operate"),
                      fixed: "right",
                      width: _vm.dynamicWidth,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                  "text-align": "left",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn-plain-primary",
                                    attrs: {
                                      disabled:
                                        scope.row.status === "1" ||
                                        !_vm.checkPol,
                                      type: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAddBooking(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("home.controlOne")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      "flex-direction": "column",
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        class: {
                                          "el-icon-goods-class":
                                            !scope.row.slotControlStatus ||
                                            scope.row.slotControlStatus ==
                                              "0" ||
                                            scope.row.status === "1" ||
                                            !_vm.checkPol,
                                          "el-icon-goods": true,
                                        },
                                        staticStyle: {
                                          cursor: "pointer",
                                          "font-size": "12px",
                                          color: "#56bcee",
                                          margin: "0px 0 8px 5px",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("home.bookingPromotion")
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    !scope.row.flag &&
                                    _vm.listQuery.isTs == "1" &&
                                    _vm.checkPol
                                      ? _c(
                                          "i",
                                          {
                                            staticClass:
                                              "button-icon el-icon-arrow-down",
                                            staticStyle: {
                                              margin: "0px 0 0px 5px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toogleExpand(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("home.lookDetail"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    scope.row.flag &&
                                    _vm.listQuery.isTs == "1" &&
                                    _vm.checkPol
                                      ? _c(
                                          "i",
                                          {
                                            staticClass:
                                              "button-icon el-icon-arrow-down",
                                            staticStyle: {
                                              margin: "0px 0 0px 5px",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.toogleExpand(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("home.hideDetail"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                staticClass: "pagePanel",
                staticStyle: { "text-align": "left" },
                attrs: {
                  total: _vm.total,
                  page: _vm.listQuery.currentPage,
                  limit: _vm.listQuery.pageSize,
                },
                on: {
                  "update:page": function ($event) {
                    return _vm.$set(_vm.listQuery, "currentPage", $event)
                  },
                  "update:limit": function ($event) {
                    return _vm.$set(_vm.listQuery, "pageSize", $event)
                  },
                  pagination: _vm.searchFn,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("CheckNotice", {
        ref: "checkNotice",
        on: { handleCheckSubmit: _vm.handleCheckSubmit },
      }),
      _vm._v(" "),
      _c("checkNoticePrice", {
        ref: "checkNoticePrice",
        on: { handleCheckPriceSubmit: _vm.handleCheckPriceSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }